
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtotest",
      function () {
        return require("private-next-pages/avtotest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtotest"])
      });
    }
  